import { FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup } from "@material-ui/core";
import arrayMove from "array-move";
import { useCallback, useEffect, useState } from "react";
import {
  BooleanInput, //
  Create,
  Link,
  SimpleForm,
  useDataProvider,
  useNotify,
  useRedirect,
} from "react-admin";
import { useForm } from "react-final-form";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import { useHistory } from "react-router-dom";
import { MyDateTimeInput } from "../MyDateTimeInput";

import moment from "moment-timezone";
import queryString from "query-string";

const platformChoices = [
  { id: "all", name: "All" },
  { id: "stb", name: "STB" },
  { id: "android_tv", name: "Android TV" },
  { id: "samsung_tv", name: "Samsung TV" },
  { id: "lg_tv", name: "LG TV" },
  { id: "ios", name: "iOS" },
  { id: "android", name: "Android" },
  { id: "web", name: "Web" },
];

const regionChoices = [
  { id: "all", name: "All" },
  { id: "HK", name: "HK" },
  { id: "MO", name: "MO" },
];

const getMpmSearch = (type, platform, region) => queryString.stringify({ type, ...(platform !== "all" && { platform }), ...(region !== "all" && { region }) });

const getSlotSearch = (slot_id, type, platform, region) =>
  queryString.stringify({ slot_id, type, returnTo: `/mpm?${getMpmSearch(type, platform, region)}` });

const matchesSelection = (record, platform, region) => {
  const recordRegions = record.region ?? record.locations?.allowlist?.countries;
  const matchesPlatform = platform === "all" || (Array.isArray(record.platform) && record.platform.includes(platform));
  const matchesRegion = region === "all" || (Array.isArray(recordRegions) && recordRegions.includes(region));

  return matchesPlatform && matchesRegion;
};

const PreviewFilterRadioGroup = ({ label, value, choices, onChange }) => (
  <FormControl component="fieldset" style={{ width: "100%" }}>
    <FormLabel component="legend" style={{ color: "black" }}>
      {label}
    </FormLabel>
    <RadioGroup row value={value} onChange={onChange}>
      {choices.map((choice) => (
        <FormControlLabel key={choice.id} value={choice.id} control={<Radio color="primary" />} label={choice.name} />
      ))}
    </RadioGroup>
  </FormControl>
);

const MPMGrid = SortableContainer(({ type, slots, max_slot_id, displaySlots, platform, region }) => {
  if (!slots) {
    return <></>;
  }

  var hasAddButton = max_slot_id < 999999;

  return (
    <Grid container spacing={1}>
      {displaySlots}

      {hasAddButton ? (
        <Grid id="action-link" item xs={6} md={3}>
          <Link className="link-to-slot-new" id="link-to-new" to={`slots?${getSlotSearch(max_slot_id + 1, type, platform, region)}`}>
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABmJLR0QA/wD/AP+gvaeTAAAA50lEQVR4nO3ZQQrCUBAE0dZziOdRvP8F8nMPXWggceMuL0gXDGQ39QuymqQUxSPJnGQkuWMXwkjy/MykJE5qcd4PX0NczmLpkWgALaBpAC2gaQAtoGkALaBpAC2gaQAtoGkALaBpAC2gaQAtoGkALaBpAC2gaQAtoFkHWG51z53mm732bm6R63PUSHL53ewvGEmuSX+BDfdsL7b/OlOS2/LoXofF0iPRAFpA0wBaQNMAWkDTAFpA0wBaQNMAWkDTAFpA0wBaQNMAWkDTAFpA0wBaQNMAWkAjA8yr78EsIMstcnOrK2VfXmMffu4mXwiGAAAAAElFTkSuQmCC" />
          </Link>
        </Grid>
      ) : (
        <></>
      )}
    </Grid>
  );
});

const MPMGridItem = SortableElement(({ record, slot_id, type, platform, region, isFiltering }) => {
  if (!record) {
    //No this slot
    return (
      <Grid item xs={6} md={3} style={{ zIndex: 9999, display: isFiltering ? "none" : undefined }}>
        {/* the Link to is not working because SortableElement digested it  */}
        <Link className="mpm-list" style={{ textAlign: "center", color: "black", textDecoration: "none" }} to={`slots?${getSlotSearch(slot_id, type, platform, region)}`}>
          <span> Currently there is no active content in this slot</span>
        </Link>
      </Grid>
    );
  }

  return (
    <Grid item xs={6} md={3} style={{ zIndex: 9999 }}>
      {/* the Link to is not working because SortableElement digested it  */}
      <Link className="mpm-list" to={`slots?${getSlotSearch(slot_id, type, platform, region)}`}>
        <img src={record.landscape_poster} style={{ width: "100%" }} />
      </Link>
    </Grid>
  );
});

const PlaylistBooleanInput = ({ type, autoplay, mpmRowSchedules, setAutoplay }) => {
  const form = useForm();
  const dataProvider = useDataProvider();
  const notify = useNotify();

  const onPlaylistChanged = async (val) => {
    if (val) {
      //Check if any invalid slots
      const invalidSlots = [];
      for (const data of mpmRowSchedules) {
        if (!["episode"].includes(data.content_type)) {
          invalidSlots.push(data.slot_id);
        }
      }

      if (invalidSlots.length > 0) {
        notify(`For a playlist, item content type must be “episode”, please check slot ${invalidSlots.join(", ")}`, "error");
        form.change("playlist", !val); //Reset the checkbox
        return;
      }
    }

    try {
      await dataProvider.updateEditorialAutoplay("", {
        data: { type: type, mpmRowSchedules: mpmRowSchedules, autoplay: val },
      });
      setAutoplay(val);
    } catch (error) {
      console.error("Error updating editorial autoplay:", error);
      notify(error.message.toString(), "error");
      form.change("playlist", !val); //Reset the checkbox
      return;
    }
  };

  return <BooleanInput label="Playlist" source="playlist" initialValue={autoplay} onChange={onPlaylistChanged} style={{ textAlign: "left", display: "table-cell", verticalAlign: "middle" }} />;
};

var type;
// var name;

export const MPMList = (props) => {
  const parsed = queryString.parse(props.location.search);

  if (parsed.type) {
    type = parsed.type;
  }
  // if (parsed.name) {
  //   name = parsed.name;
  // }

  //TODO: Maybe we don't need `name` from url?
  const dataProvider = useDataProvider();

  const redirect = useRedirect();
  const history = useHistory();

  // const [previewDate, setPreviewDate] = useState(moment.utc()); //Store moment object, with correct timezone
  const [previewDate, setPreviewDate] = useState(moment.tz("Asia/Hong_Kong")); //ALWAYS Store in UTC+8 timezone
  const [response, setResponse] = useState();
  const [mpmRowScheduleTypesResponse, setMpmRowScheduleTypesResponse] = useState();
  const [autoplay, setAutoplay] = useState(false);
  const [name, setName] = useState("");
  const [slots, setSlots] = useState([]);
  const [displaySlots, setDisplaySlots] = useState([]);
  const [platform, setPlatform] = useState(parsed.platform || "all");
  const [region, setRegion] = useState(parsed.region || "all");

  const updateFilters = (nextPlatform, nextRegion) => {
    setPlatform(nextPlatform);
    setRegion(nextRegion);
    history.replace({
      search: `?${getMpmSearch(type, nextPlatform, nextRegion)}`,
    });
  };

  const updateDisplaySlots = useCallback(
    (sourceSlots, max_slot_id) => {
      const result = [];
      const filteredSlots = sourceSlots.filter((slot) => matchesSelection(slot, platform, region));
      const isFiltering = platform !== "all" || region !== "all";

      // loop till max slot id
      for (var index = 0; index < max_slot_id; index++) {
        const slot = filteredSlots.find((item) => item.slot_id == index + 1);

        if (slot) {
          result.push(<MPMGridItem record={slot} slot_id={index + 1} type={type} platform={platform} region={region} key={index} index={index} isFiltering={isFiltering} disabled={isFiltering} />);
        } else {
          result.push(<MPMGridItem record={null} slot_id={index + 1} type={type} platform={platform} region={region} key={index} index={index} isFiltering={isFiltering} disabled={isFiltering} />);
        }
      }

      setDisplaySlots(result);
    },
    [platform, region]
  );

  const refreshSlot = useCallback(() => {
    dataProvider
      .getPreviewSlot(type, previewDate)
      .then((res) => {
        res.data.data.sort((a, b) => a.slot_id - b.slot_id);
        setResponse(res.data);
        setSlots(res.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [dataProvider, previewDate, type]);

  useEffect(() => {
    if (response) {
      updateDisplaySlots(slots, response.max_slot_id);
    }
  }, [response, slots, updateDisplaySlots]);

  //Refresh slot when previewDate changes
  useEffect(() => {
    //Make sure we have set autoplay already, incorect result otherwise.
    if (mpmRowScheduleTypesResponse) {
      refreshSlot();
    }
  }, [mpmRowScheduleTypesResponse, refreshSlot]);

  //Get MPM Row Schedule Types
  useEffect(async () => {
    const result = await dataProvider.getMpmRowScheduleTypeByType(type);
    setAutoplay(result.data.autoplay ?? false);
    setName(result.data.name ?? "");
    setMpmRowScheduleTypesResponse(result.data);
  }, []);

  if (!response || !mpmRowScheduleTypesResponse) {
    return <></>;
  }

  const onPreviewDateChange = (e) => {
    //Note: This is HK time, create moment object in HK time
    var x = moment.tz(e.target.value, "Asia/Hong_Kong");
    setPreviewDate(x);
  };

  const onSortEnd = async ({ oldIndex, newIndex }) => {
    if (platform !== "all" || region !== "all") {
      return;
    }

    // sim the onClick on the Link because the SortableElement digested it
    if (oldIndex == newIndex) {
      redirect(`slots?${getSlotSearch(oldIndex + 1, type, platform, region)}`);

      return;
    }

    // local change
    var updatedSlots = arrayMove(displaySlots, oldIndex, newIndex); //Reorder Row
    setDisplaySlots(updatedSlots);

    // call api
    await dataProvider.updateSlotOrder({
      type: type,
      slot_id: oldIndex + 1,
      new_slot_id: newIndex + 1,
    });

    refreshSlot();
  };

  return (
    <Create {...props} title={name}>
      <SimpleForm toolbar={<></>}>
        <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
          <div>
            <MyDateTimeInput label="Preview Date" source="previewDate" initialValue={previewDate.format("YYYY-MM-DDTHH:mm", false)} onChange={onPreviewDateChange} style={{ textAlign: "left" }} />
          </div>
          <div style={{ marginLeft: "80px" }}>
            <PlaylistBooleanInput type={type} autoplay={autoplay} mpmRowSchedules={response.data} setAutoplay={setAutoplay} />
          </div>
          <div id="editorial_name" className="editorial_name" style={{ textAlign: "right", flex: 1 }}>
            <label>Editorial Name: </label>
            <span>
              <b>{name}</b>
            </span>
          </div>
        </div>

        <Grid container spacing={2} style={{ width: "100%" }}>
          <Grid item xs={12} md={9}>
            <PreviewFilterRadioGroup label="Platform" value={platform} choices={platformChoices} onChange={(event) => updateFilters(event.target.value, region)} />
          </Grid>
          <Grid item xs={12} md={3}>
            <PreviewFilterRadioGroup label="Region" value={region} choices={regionChoices} onChange={(event) => updateFilters(platform, event.target.value)} />
          </Grid>
        </Grid>

        <MPMGrid type={type} name={name} slots={slots} displaySlots={displaySlots} max_slot_id={response.max_slot_id} platform={platform} region={region} autoplay={autoplay} onSortEnd={onSortEnd} axis="xy" hideSortableGhost="true" />
      </SimpleForm>
    </Create>
  );
};
